import { IdOcrFieldBinder } from '../../binders/daq';
import { Gizmo } from '../../gizmos';
import { IRootGizmoData } from '../../types';

interface IParams {
  variable: string;
  context: {
    gizmo?: Gizmo;
  };
}

/**
 * Function to be called by influx to get parent data
 *
 * @param {string} variable reference to parent data
 * @returns
 */
async function parentData({ variable, context }: IParams) {
  const [uid, ...accessor] = variable.split('.');
  const { gizmo } = context;

  const rootGizmoData: IRootGizmoData = gizmo?.getCallbacks().getInfoCB({
    type: 'rootGizmoData',
  });

  if (
    rootGizmoData.belongsTo &&
    typeof rootGizmoData.belongsTo === 'object' &&
    rootGizmoData.belongsTo.filledFormId &&
    uid &&
    accessor[0]
  ) {
    const parentFoundation = gizmo
      ?.getFoundation()
      ?.getGlobal()
      ?.getFoundation({
        fid: rootGizmoData.belongsTo.filledFormId,
      });
    let parentGizmo: Gizmo | undefined;

    if (accessor[0].match(/^\s*q_?\d*\s*/g)) {
      parentGizmo = parentFoundation?.getRootGizmo()?.findGizmo({
        fid: accessor[0],
      }) as Gizmo;
    } else {
      parentGizmo = parentFoundation?.getRootGizmo()?.findGizmo({
        uid: accessor[0],
      }) as Gizmo;
    }

    const data = parentGizmo?.getData();

    if (
      data &&
      parentGizmo.getConfig().type === 'id_ocr_field' &&
      parentGizmo
    ) {
      const binder: IdOcrFieldBinder = parentGizmo.getBinder();
      const files = binder.getFiles();

      if (files && typeof files === 'object') {
        return { data, files };
      }
    } else if (data && !Array.isArray(data) && data.v !== undefined) {
      return data.v;
    }
  }

  return undefined;
}

export default parentData;
